import dayjs from 'dayjs'
import { PostDTO } from '~/domain/post/dto/PostDTO'

export interface Props {
  post: PostDTO
}

export const usePostItem = (props: Props) => {
  const { post } = props
  const publishedAt = dayjs(post.publishedAt).format('YYYY.MM.DD')

  return {
    post,
    publishedAt,
  }
}
